import StringifyRequest from '@/types/api/stringify-request'

const defaultStringifyRequest: StringifyRequest = {
  stringify: true,
  array_format: 'bracket',
} as const

export default defaultStringifyRequest
